var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container seg-content general user" }, [
      _c("section", { staticClass: "home-list" }, [
        _c("div", { staticClass: "hl-wid ww4 watch-filter" }, [
          _c("h4", [_vm._v("Test stats")]),
          _vm._v(" "),
          _c("form", { staticClass: "user-form filter" }, [
            _c(
              "div",
              { staticClass: "filter-field" },
              [
                _c("label", [_vm._v("User")]),
                _vm._v(" "),
                _c("keyval-select", {
                  attrs: { options: _vm.users },
                  on: { input: _vm.loadWatchStats },
                  model: {
                    value: _vm.userId,
                    callback: function($$v) {
                      _vm.userId = $$v
                    },
                    expression: "userId"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-field" },
              [
                _c("label", [_vm._v("Test")]),
                _vm._v(" "),
                _c("keyval-select", {
                  attrs: { options: _vm.videos },
                  on: { input: _vm.loadWatchStats },
                  model: {
                    value: _vm.videoId,
                    callback: function($$v) {
                      _vm.videoId = $$v
                    },
                    expression: "videoId"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        !(_vm.userId * 1) && !(_vm.videoId * 1)
          ? _c("div", { staticClass: "hl-wid ww4 test-totals" }, [
              _c("h4", [_vm._v("Select a user or test")])
            ])
          : !(_vm.userId * 1) && _vm.videoId * 1
          ? _c("div", { staticClass: "hl-wid ww4 test-totals" }, [
              _c("h4", [
                _vm._v(
                  "Test: " +
                    _vm._s(
                      _vm.currentTest.parent
                        ? _vm.currentTest.parent.subtitle
                        : _vm.currentTest.subtitle
                    ) +
                    " " +
                    _vm._s(_vm.currentTest.title)
                )
              ]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.usersForTest, function(testTakes) {
                  return _c("li", [
                    _c("span", [
                      _vm._v(
                        _vm._s(testTakes.user.firstname) +
                          " " +
                          _vm._s(testTakes.user.lastname)
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Passed " +
                          _vm._s(
                            testTakes.answers.filter(function(a) {
                              return a.passed * 1
                            }).length
                          ) +
                          " of " +
                          _vm._s(testTakes.answers.length)
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c(
                        "a",
                        {
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.userId = testTakes.user.id + ""
                              _vm.loadWatchStats()
                            }
                          }
                        },
                        [_vm._v("View answers")]
                      )
                    ])
                  ])
                }),
                0
              )
            ])
          : _vm.userId * 1 && !(_vm.videoId * 1)
          ? _c("div", { staticClass: "hl-wid ww4 test-totals" }, [
              _c("h4", [
                _vm._v(
                  "User: " +
                    _vm._s(
                      _vm.currentUser.firstname + " " + _vm.currentUser.lastname
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.testsForUser, function(testTakes) {
                  return _c("li", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          testTakes.video.parent
                            ? testTakes.video.parent.subtitle
                            : testTakes.video.subtitle
                        ) +
                          " " +
                          _vm._s(testTakes.video.title)
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Passed " +
                          _vm._s(
                            testTakes.answers.filter(function(a) {
                              return a.passed * 1
                            }).length
                          ) +
                          " of " +
                          _vm._s(testTakes.answers.length)
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _c(
                        "a",
                        {
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.videoId = testTakes.video.id + ""
                              _vm.loadWatchStats()
                            }
                          }
                        },
                        [_vm._v("View answers")]
                      )
                    ])
                  ])
                }),
                0
              )
            ])
          : _vm.userId * 1 && _vm.videoId * 1
          ? _c("div", { staticClass: "hl-wid ww4 test-totals" }, [
              _c("h4", [
                _vm._v(
                  "User: " +
                    _vm._s(
                      _vm.currentUser.firstname + " " + _vm.currentUser.lastname
                    )
                )
              ]),
              _vm._v(" "),
              _c("h4", [
                _vm._v(
                  "Test: " +
                    _vm._s(
                      _vm.currentTest.parent
                        ? _vm.currentTest.parent.subtitle
                        : _vm.currentTest.subtitle
                    ) +
                    " " +
                    _vm._s(_vm.currentTest.title)
                )
              ]),
              _vm._v(" "),
              _vm.testsFor.qs && _vm.testsFor.qs.type == "independent"
                ? _c(
                    "table",
                    { staticClass: "test-answers" },
                    [
                      _c(
                        "tr",
                        { staticClass: "prop adate" },
                        [
                          _c("th", [_vm._v("Date:")]),
                          _vm._v(" "),
                          _vm._l(_vm.testsFor.answers || [], function(answer) {
                            return _c(
                              "td",
                              {
                                attrs: {
                                  title: _vm.formatDate(
                                    answer.created,
                                    "MMM Do, YYYY h:mma"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(answer.created, "MMM Do")
                                  )
                                )
                              ]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        { staticClass: "prop total" },
                        [
                          _c("th", [_vm._v("Total questions:")]),
                          _vm._v(" "),
                          _vm._l(_vm.testsFor.answers || [], function(answer) {
                            return _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.testsFor.qs.independent.questions.length
                                )
                              )
                            ])
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        { staticClass: "prop treshold" },
                        [
                          _c("th", [_vm._v("Passing score:")]),
                          _vm._v(" "),
                          _vm._l(_vm.testsFor.answers || [], function(answer) {
                            return _c("td", [
                              _vm._v(
                                _vm._s(_vm.testsFor.qs.independent.passingScore)
                              )
                            ])
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        { staticClass: "prop score" },
                        [
                          _c("th", [_vm._v("Score:")]),
                          _vm._v(" "),
                          _vm._l(_vm.testsFor.answers || [], function(answer) {
                            return _c(
                              "td",
                              {
                                class: {
                                  pass:
                                    answer.result >=
                                    _vm.testsFor.qs.independent.passingScore
                                }
                              },
                              [_vm._v(_vm._s(answer.result))]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.testsFor.qs.independent.questions, function(
                        question,
                        qi
                      ) {
                        return [
                          _c(
                            "tr",
                            { staticClass: "question" },
                            [
                              _c("th", { staticClass: "question" }, [
                                _vm._v(_vm._s(question.text))
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.testsFor.answers || [], function(
                                answer
                              ) {
                                return _c("td", { staticClass: "qresult" }, [
                                  _c("em", {
                                    class: {
                                      valid: _vm.isAnswerValid(answer, qi)
                                    }
                                  })
                                ])
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm._l(question.answers, function(answer, ai) {
                            return _c(
                              "tr",
                              { staticClass: "answer" },
                              [
                                _c(
                                  "th",
                                  {
                                    staticClass: "answer",
                                    class: { correct: answer.valid }
                                  },
                                  [_vm._v(_vm._s(answer.text))]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.testsFor.answers || [], function(
                                  answer
                                ) {
                                  return _c("td", { staticClass: "aresult" }, [
                                    _c("em", {
                                      class: {
                                        selected: _vm.isSelected(
                                          answer,
                                          qi,
                                          ai
                                        ),
                                        correct: _vm.isCorrect(answer, qi, ai),
                                        valid: _vm.isValid(answer, qi, ai)
                                      }
                                    })
                                  ])
                                })
                              ],
                              2
                            )
                          })
                        ]
                      })
                    ],
                    2
                  )
                : _vm._e()
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }